//Pages/Home/Home.jsx
// CSS
import "./home-page.css";

// Sections
import HomeHero from "../../components/HomeHero/HomeHero";
import { useLocation, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import { useEffect } from "react";

const Home = () => {
  const location = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    // Check if a success message was passed in the state
    if (location.state?.success) {
      toast(location.state.success); // Display the success toast
      // Clear the state after displaying the toast
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [location, navigate]);

  return (
    <main className="home-page">
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
      />
      <HomeHero />
    </main>
  );
};

export default Home;
